import { Pawsible_Intro } from './PawsibleIntro';
import { Canine_Fundamentals } from './CanineFundamentals';
import { Feline_Fundamentals } from './FelineFundamentals';
import { Communication_Service } from './CommunicationAndService';
import { Professionalism_Growth } from './ProfessionalismAndGrowth';


export const CORE_CONCEPT_DETAILS = {
    ...Pawsible_Intro,
    ...Canine_Fundamentals,
    ...Feline_Fundamentals,
    ...Communication_Service,
    ...Professionalism_Growth,
};